import {Pipe, PipeTransform} from '@angular/core';

/**
 * 排序使用
 * key：排序关键词
 * order: asc/desc 升序降序
 */
@Pipe({name: 'sort'})
export class SortPipe implements PipeTransform {
  transform(dataList: [any], key: string, order: string): [any] {
    let flag = 1;
    if (order) {
      if (order.toLowerCase() === 'desc') {
        flag = flag * (-1);
      }
    }
    if (!dataList) {
      return dataList;
    }
    return dataList.sort((a, b) => {
      if (a[key] > b[key]) {
        return 1 * flag;
      } else if (a[key] < b[key]) {
        return -1 * flag;
      } else {
        return 0;
      }
    });
  }
}
